<template>
  <div id="app">
    <router-view></router-view>
    <compliance-block-dialog/>
  </div>
</template>

<script>
import ComplianceBlockDialog from "./views/components/ComplianceBlockDialog.vue";

export default {
  name: "App",
  components: {
    ComplianceBlockDialog
  }
};
</script>
<style>
:focus {
  outline: none;
}
.mainpage {
  scroll-behavior: smooth;
}
body {
  font-size: 14px;
  overflow: hidden;
}

.el-loading-spinner .path {
  stroke: #fff;
}

.el-loading-mask {
  background: rgba(0, 0, 0, 0.51);
}

.el-input__suffix-inner .el-input__icon {
  line-height: 0;
}

.el-input-number .el-input__inner {
  text-align: left;
}

.footer,
.header {
  font-family: Arial, "微软雅黑", sans-serif;
}

.el-form-item__content {
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/App.vue